module.exports = __webpack_public_path__ + "img/stix.c6367b73.svg";